// extracted by mini-css-extract-plugin
export default {"logger":"Logger_logger__sg9QW","closeButton":"Logger_closeButton__3puQc"};